export const CAREGIVER_SHIFT_REPORT_DEFAULT_SORT = {
  sortedColumn: 'startDate',
  sortedColumnOrder: 'descend'
}
